export default "__VITE_ASSET__BnbaY$hB__"